/* eslint-disable import/first */
import React from "react";

import async from "../components/Async";

import {
  Briefcase,
  Calendar as CalendarIcon,
  CheckSquare,
  CreditCard,
  Grid,
  Heart,
  Layout,
  List,
  Map,
  Monitor,
  ShoppingCart,
  PieChart,
  Sliders,
  Users,
  Twitch,
  File,
  UploadCloud,
} from "react-feather";

// All pages that rely on 3rd party components (other than Material-UI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Guards
import AuthGuard from "../components/AuthGuard";

// Auth components
import SignIn from "../pages/auth/SignIn";
import SignUp from "../pages/auth/SignUp";
import ResetPassword from "../pages/auth/ResetPassword";
import Page404 from "../pages/auth/Page404";
import Page500 from "../pages/auth/Page500";

// Components components
// import Accordion from "../pages/components/Accordion";
// import Alerts from "../pages/components/Alerts";
// import Avatars from "../pages/components/Avatars";
// import Badges from "../pages/components/Badges";
// import Buttons from "../pages/components/Buttons";
// import Cards from "../pages/components/Cards";
// import Chips from "../pages/components/Chips";
// import Dialogs from "../pages/components/Dialogs";
// import Lists from "../pages/components/Lists";
// import Menus from "../pages/components/Menus";
// import Pagination from "../pages/components/Pagination";
// import Progress from "../pages/components/Progress";
// import Snackbars from "../pages/components/Snackbars";
// import Tooltips from "../pages/components/Tooltips";

// Dashboards components
const Default = async(() => import("../pages/dashboards/Default"));

const Analytics = async(() => import("../pages/dashboards/Analytics"));
// const SaaS = async(() => import("../pages/dashboards/SaaS"));

// Forms components
import SelectionCtrls from "../pages/forms/SelectionControls";
import Selects from "../pages/forms/Selects";
import TextFields from "../pages/forms/TextFields";
const Pickers = async(() => import("../pages/forms/Pickers"));
const Dropzone = async(() => import("../pages/forms/Dropzone"));
const Editors = async(() => import("../pages/forms/Editors"));
const Formik = async(() => import("../pages/forms/Formik"));

// Icons components
import MaterialIcons from "../pages/icons/MaterialIcons";
const FeatherIcons = async(() => import("../pages/icons/FeatherIcons"));

// Pages components
import Blank from "../pages/pages/Blank";
import InvoiceDetails from "../pages/pages/InvoiceDetails";
import InvoiceList from "../pages/pages/InvoiceList";
import Orders from "../pages/pages/Orders";
import Pricing from "../pages/pages/Pricing";
import Settings from "../pages/pages/Settings";
import Projects from "../pages/pages/Projects";
import Chat from "../pages/pages/Chat";
const Profile = async(() => import("../pages/pages/Profile"));
const Tasks = async(() => import("../pages/pages/Tasks"));
const Calendar = async(() => import("../pages/pages/Calendar"));

// Tables components
// import SimpleTable from "../pages/tables/SimpleTable";
// import AdvancedTable from "../pages/tables/AdvancedTable";

// Chart components
// const Chartjs = async(() => import("../pages/charts/Chartjs"));

// Maps components
const GoogleMaps = async(() => import("../pages/maps/GoogleMaps"));
const VectorMaps = async(() => import("../pages/maps/VectorMaps"));

// Documentation
// import Welcome from "../pages/docs/Welcome";
// import GettingStarted from "../pages/docs/GettingStarted";
// import EnvironmentVariables from "../pages/docs/EnvironmentVariables";
// import Deployment from "../pages/docs/Deployment";
// import Theming from "../pages/docs/Theming";
// import StateManagement from "../pages/docs/StateManagement";
// import APICalls from "../pages/docs/APICalls";
// import ESLintAndPrettier from "../pages/docs/ESLintAndPrettier";
// import Support from "../pages/docs/Support";
import Changelog from "../pages/docs/Changelog";

// Landing
import Landing from "../pages/presentation/Landing";

// Protected routes
import ProtectedPage from "../pages/protected/ProtectedPage";

const dashboardsRoutes = {
  id: "Dashboard",
  path: "/dashboard/analytics",
  header: "Pages",
  icon: <Sliders />,
  containsHome: true,
  children: [
    // {
    //   path: "/dashboard/default",
    //   name: "Default",
    //   component: Default,
    // },
    {
      path: "/dashboard/analytics",
      name: "Analytics",
      component: Analytics,
    },
    // {
    //   path: "/dashboard/saas",
    //   name: "SaaS",
    //   component: SaaS,
    // },
  ],
  component: null,
};

const pagesRoutes = {
  id: "Biling",
  path: "/pages",
  icon: <Layout />,
  children: [
    {
      path: "/pages/profile",
      name: "Profile",
      component: Profile,
    },
    {
      path: "/pages/settings",
      name: "Settings",
      component: Settings,
    },
    {
      path: "/pages/pricing",
      name: "Pricing",
      component: Pricing,
    },
    {
      path: "/pages/chat",
      name: "Chat",
      component: Chat,
    },
    {
      path: "/pages/blank",
      name: "Blank Page",
      component: Blank,
    },
  ],
  component: null,
};

const projectsRoutes = {
  id: "Projects",
  path: "/projects",
  icon: <Briefcase />,
  badge: "8",
  component: Projects,
  children: null,
};

const invoiceRoutes = {
  id: "Invoices",
  path: "/invoices",
  icon: <CreditCard />,
  children: [
    {
      path: "/invoices",
      name: "List",
      component: InvoiceList,
    },
    {
      path: "/invoices/detail",
      name: "Details",
      component: InvoiceDetails,
    },
  ],
  component: null,
};

const poleRoutes = {
  id: "Smart Poles",
  path: "/dashboard",
  icon: <Twitch />,
  children: [
    {
      path: "/dashboard/default",
      name: "Smart Poles 1",
      component: Default,
    },
    {
      path: "/dashboard/default",
      name: "Smart Poles 2",
      component: Default,
    },
    {
      path: "/dashboard/default",
      name: "Smart Poles 3",
      component: Default,
    },
    {
      path: "/dashboard/default",
      name: "Smart Poles 4",
      component: Default,
    },
    {
      path: "/dashboard/default",
      name: "Smart Poles 5",
    },
  ],
  component: null,
};

const orderRoutes = {
  id: "Orders",
  path: "/orders",
  icon: <ShoppingCart />,
  component: Orders,
  children: null,
};

const tasksRoutes = {
  id: "Tasks",
  path: "/tasks",
  icon: <CheckSquare />,
  badge: "17",
  component: Tasks,
  children: null,
};

const calendarRoutes = {
  id: "Calendar",
  path: "/calendar",
  icon: <CalendarIcon />,
  component: Calendar,
  children: null,
};

const authRoutes = {
  id: "Auth",
  path: "/auth",
  icon: <Users />,
  children: [
    {
      path: "/auth/sign-in",
      name: "Sign In",
      component: SignIn,
    },
    {
      path: "/auth/sign-up",
      name: "Sign Up",
      component: SignUp,
    },
    {
      path: "/auth/reset-password",
      name: "Reset Password",
      component: ResetPassword,
    },
    {
      path: "/auth/404",
      name: "404 Page",
      component: Page404,
    },
    {
      path: "/auth/500",
      name: "500 Page",
      component: Page500,
    },
  ],
  component: null,
};

const componentsRoutes = {
  id: "Tickets",
  path: "/pages",
  header: "Elements",
  icon: <Grid />,
  children: [
    {
      path: "/pages/blank",
      component: Blank,
      name: "New",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Opened",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Poles",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Critical",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Others",
    },
  ],
  component: null,
};

const DocsRoutes = {
  id: "Reports",
  header: "Documents",
  icon: <File />,
  children: null,
  path: "/pages/blank",
  name: "Blank Page",
  component: Blank,
};

const uploadRoutes = {
  id: "Upload Documents",
  icon: <UploadCloud />,
  children: null,
  path: "/pages/blank",
  name: "Blank Page",
  component: Blank,
};

const formsRoutes = {
  id: "Forms",
  path: "/forms",
  icon: <CheckSquare />,
  children: [
    {
      path: "/forms/pickers",
      name: "Pickers",
      component: Pickers,
    },
    {
      path: "/forms/selection-controls",
      name: "Selection Controls",
      component: SelectionCtrls,
    },
    {
      path: "/forms/selects",
      name: "Selects",
      component: Selects,
    },
    {
      path: "/forms/text-fields",
      name: "Text Fields",
      component: TextFields,
    },
    {
      path: "/forms/dropzone",
      name: "Dropzone",
      component: Dropzone,
    },
    {
      path: "/forms/editors",
      name: "Editors",
      component: Editors,
    },
    {
      path: "/forms/formik",
      name: "Formik",
      component: Formik,
    },
  ],
  component: null,
};

const homeRoutes = {
  id: "Home",
  path: "/dashboard/analytics",
  icon: <Sliders />,
  children: null,
  component: null,
};

const tablesRoutes = {
  id: "Maintenance",
  path: "/pages/blank",
  name: "Blank Page",
  component: Blank,
  icon: <List />,
  children: null,
};

const teamsRoutes = {
  id: "Team",
  path: "/pages/blank",
  name: "Blank Page",
  component: Blank,
  icon: <CheckSquare />,
  children: null,
};

const iconsRoutes = {
  id: "Icons",
  path: "/icons",
  icon: <Heart />,
  children: [
    {
      path: "/icons/material-icons",
      name: "Material Icons",
      component: MaterialIcons,
    },
    {
      path: "/icons/feather-icons",
      name: "Feather Icons",
      component: FeatherIcons,
    },
  ],
  component: null,
};

const chartRoutes = {
  id: "Labs@Resync",
  path: "/pages",
  icon: <PieChart />,
  children: [
    {
      path: "/pages/blank",
      component: Blank,
      name: "IV Curve",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Trend Analysis",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Degradation",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "HeatMap",
    },
    {
      path: "/pages/blank",
      component: Blank,
      name: "Inverter Analysis",
    },
  ],
};

const mapsRoutes = {
  id: "Maps",
  path: "/maps",
  icon: <Map />,
  children: [
    {
      path: "/maps/google-maps",
      name: "Google Maps",
      component: GoogleMaps,
    },
    {
      path: "/maps/vector-maps",
      name: "Vector Maps",
      component: VectorMaps,
    },
  ],
  component: null,
};

const landingRoutes = {
  id: "Landing Page",
  path: "/",
  header: "Docs",
  icon: <Monitor />,
  component: Landing,
  children: null,
};

const changelogRoutes = {
  id: "Changelog",
  path: "/changelog",
  badge: "v2.0.3",
  icon: <List />,
  component: Changelog,
  children: null,
};

// This route is only visible while signed in
const protectedPageRoutes = {
  id: "Private",
  path: "/private",
  component: ProtectedPage,
  children: null,
  guard: AuthGuard,
};

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  dashboardsRoutes,
  poleRoutes,
  pagesRoutes,
  projectsRoutes,
  orderRoutes,
  invoiceRoutes,
  tasksRoutes,
  calendarRoutes,
  componentsRoutes,
  chartRoutes,
  formsRoutes,
  tablesRoutes,
  iconsRoutes,
  mapsRoutes,
  changelogRoutes,
];

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes];

// Routes using the Presentation layout
export const presentationLayoutRoutes = [landingRoutes];

// Routes that are protected
export const protectedRoutes = [protectedPageRoutes];

// Routes visible in the sidebar
// export const sidebarRoutes = [
//   dashboardsRoutes,
//   pagesRoutes,
//   projectsRoutes,
//   orderRoutes,
//   invoiceRoutes,
//   tasksRoutes,
//   calendarRoutes,
//   authRoutes,
//   componentsRoutes,
//   chartRoutes,
//   formsRoutes,
//   tablesRoutes,
//   iconsRoutes,
//   mapsRoutes,
//   changelogRoutes,
// ];

export const sidebarRoutes = [
  homeRoutes,
  invoiceRoutes,
  poleRoutes,
  calendarRoutes,
  componentsRoutes,
  tablesRoutes,
  chartRoutes,
  teamsRoutes,
  DocsRoutes,
  uploadRoutes,
];
